module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAARZJREFUOE+l0r9KxEAQBvCZkJRW6lP4DopWFuID2NiEyS7YCp4Iwt2haGsgzELCdT6Af8DCtzhb0VbsLZLwSYrARe4ue7jlMt8P9tth+ufh2byqbiRJ8r2K+RcYMvOPiFz7Ih0gTdP1KIpGRGQBHBpjHvqgDtAOO+d2AIwBfAK4sNZ+LILmAu2wqp4Q0R0zn4nIzTxkKdAEiqLYLMtyTERCRAdJkjzNQr1AO5xl2V4QBK8AXowx++29N6Cqp0R0C+DeGHPkDajqLjNfEdFbXdfn1tovryfkeb5WVVUT3AYwMMY8e5eoqsdENGHmSxEZLtuFTgfOuS0AUwCPYRgO4jierrRIqtqs8ruITPqC3iX2Qd7fuAj6BRk8ZxHgqhhyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/whole.png
// module id = tyim
// module chunks = 1